var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Transition', {
    attrs: {
      "appear": ""
    }
  }, [_c('BaseIcon', {
    staticClass: "m-auto d-block",
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }